import { useDispatch, useSelector } from 'react-redux';
import { logout as _logout, selectAuth, selectAuthStatus } from '@/store/features';
import { useCallback } from 'react';
import { useAuthControllerLogoutMutation } from '@/store/services/MidleNestApi.service';
import { baseApi } from '@/store/services';

export const useAuth = () => {
  const [mutation] = useAuthControllerLogoutMutation();
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(selectAuthStatus);
  const auth = useSelector(selectAuth);
  const checkRole = useCallback(
    (roles: string[]) => roles.some((role) => auth.roles?.includes(role)),
    [],
  );
  const logout = useCallback(() => {
    mutation()
      .unwrap()
      .finally(() => {
        dispatch(_logout());
        dispatch(baseApi.util.resetApiState());
      });
  }, []);
  return { isAuthenticated, checkRole, roles: auth.roles, logout };
};
